<div [class]="bannerClass()" [attr.role]="ariaRole()">
  <app-icon [src]="iconSrc()" [size]="24" [colorable]="true" />
  <div class="banner__body">
    @if (title(); as t) {
      <p class="banner__title body-md-semibold">{{ t }}</p>
    }
    @if (description(); as content) {
      <p class="banner__content body-md-regular">{{ content }}</p>
    }
  </div>
  @if (buttonLabel(); as label) {
    <app-button size="small" variant="secondary" (click)="buttonClicked.emit()">{{ label }}</app-button>
  }
  @if (dismissible()) {
    <button
      class="banner__close"
      type="button"
      [attr.aria-label]="'components.banner.close' | transloco"
      (click)="dismissed.emit()"
    >
      <app-icon src="icons/common/close_icon.svg" [size]="16" [colorable]="true" />
    </button>
  }
</div>
